const CHARS = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

const getRandomBytes = (len: number): number[] => {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const bytes = new Uint8Array(len);
    crypto.getRandomValues(bytes);
    return Array.from(bytes);
  }
  return Array.from({ length: len }, () => Math.floor(Math.random() * 256));
};

export const uuid = (): string => {
  return getRandomBytes(11).map((b) => CHARS[b % 62]).join('');
};

export const uuidby = (id: string) => {
  let num = Number.parseInt(id, 36);
  return (num + 9999).toString(36);
}